import React, { memo } from "react";

export const ListDocs = memo(({ tiposDocs }: any) => {
    return tiposDocs?.map((value: any) => (
        value.$$href && value.$$title &&
        <option value={value.$$href}>{value.descTipoDocumento}</option>
    ))
});